// @file utility functions for table layout padlets
import type { WallCustomPostProperty } from '@@/types'

interface BaseTableColumn {
  label: string
  show: boolean
  width: number
}

export interface StandardTableColumn extends BaseTableColumn {
  field: 'author' | 'published_at' | 'subject' | 'body' | 'attachment' | 'location' | 'spacer'
}

export interface NonPostAttributeTableColumn extends BaseTableColumn {
  field: 'reactions' | 'comments' | 'spacer' | 'row_number'
}

export interface CustomTableColumn extends BaseTableColumn {
  field: `custom_${string}`
  customProperty: WallCustomPostProperty
}

export type TableColumn = StandardTableColumn | CustomTableColumn | NonPostAttributeTableColumn

export function shouldShowEndBorder(column: TableColumn, index: number, tableColumns: TableColumn[]): boolean {
  return (
    Boolean(tableColumns[index + 1]?.label) && // the next column exists and is not empty (eg spacer)
    Boolean(column.label) // the current column exists and is not empty (eg spacer)
  )
}

export function isCustomPropertyTableColumn(column: TableColumn): column is CustomTableColumn {
  return 'customProperty' in column
}

export function isNonPostAttributeTableColumn(column: TableColumn): column is NonPostAttributeTableColumn {
  return (
    column.field === 'reactions' ||
    column.field === 'comments' ||
    column.field === 'row_number' ||
    column.field === 'spacer'
  )
}

export const getColumnLetter = (index: number): string => {
  const base = 26
  let result = ''
  let num = index

  do {
    const remainder = num % base
    result = String.fromCharCode(65 + remainder) + result // 65 is ASCII for 'A'
    num = Math.floor(num / base) - 1
  } while (num >= 0)

  return result
}
